/**
 * 表单校验规则工厂
 * 功能：提供客服人员分配、标签配置、模板配置三套规则
 */
/** 客服人员分配表单校验规则 */
export const getCustomerServiceRules = () => {
    return {
        userId: [{
            required: true,
            message: "请选择客服人员",
            trigger: "change",
        }],
        ebayAccountId: [{
            required: true,
            message: "请选择平台账号",
            trigger: "change",
        }],
        email: [{
            required: true,
            message: "请填写收件邮箱",
            trigger: "blur",
        }]

    }

}
/** 标签配置表单校验规则 */
export const getLabelConfigRules = () => {
    return {
        name: [{
            required: true,
            message: "请填写标签名称",
            trigger: "blur",
        }],
        enName: [{
            required: true,
            message: "请填写标签英文名称",
            trigger: "blur",
        }],
        color: [{
            required: true,
            message: "请选择标签颜色",
            trigger: "blur",
        }],
    }

}
/** 模板配置表单校验规则 */
export const getTemplateRules = () => {
    return {
        isOpen: [{
            required: true,
            message: "请选择是否公开",
            trigger: "blur",
        }],
        name: [{
            required: true,
            message: "请填写模板名称",
            trigger: "blur",
        }],
        content: [{
            required: true,
            message: "请填写模板内容",
            trigger: "blur",
        }],

    }

}